import React from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { Avatar } from './Avatar';
import { InlinePopover } from './InlinePopover';
import { teamMembers } from '../../data/conditions';
import { getMember } from '../../utils/conditions';
interface AssigneeSelectProps {
  value: string;
  onChange: (id: string) => void;
  conditionName: string;
}
export function AssigneeSelect({
  value,
  onChange,
  conditionName
}: AssigneeSelectProps) {
  const current = getMember(value);
  return <InlinePopover ariaLabel={`Assigned to ${current.name} for ${conditionName}. Change assignee`} triggerClassName="group inline-flex items-center gap-0.5 rounded-full p-0.5 hover:bg-slate-100" trigger={<>
          <Avatar member={current} size="sm" data-id="element-60" data-mp="mhj9wreay60e" />
          <ChevronDownIcon className="h-3 w-3 text-slate-400 opacity-0 transition-opacity group-hover:opacity-100" aria-hidden="true" data-id="element-61" data-mp="2lsu1p1wg9mt2" />
        </>} data-id="element-59" data-mp="wdmgqak3msto">
      {close => <ul role="listbox" aria-label="Assignee" className="w-60 rounded-md border border-slate-200 bg-white py-1 shadow-lg" data-id="element-62" data-mp="1oov1dcxn2p5m">
          {teamMembers.map(m => {
        const selected = m.id === value;
        return <li key={m.id} data-id="element-63" data-mp="1eshz3qo132z9">
                <button type="button" role="option" aria-selected={selected} onClick={() => {
            onChange(m.id);
            close();
          }} className="flex w-full items-center gap-2.5 px-3 py-2 text-left hover:bg-slate-50 focus:bg-slate-50 focus:outline-none" data-id="element-64" data-mp="1et9ub0dpqyp0">
                  <Avatar member={m} size="sm" data-id="element-65" data-mp="22ow12p263qji" />
                  <span className="min-w-0 flex-1" data-id="element-66" data-mp="22nkwwo4t8grv">
                    <span className="block text-sm font-medium text-slate-800" data-id="element-67" data-mp="2qeqdj5ikrd38">{m.name}</span>
                    <span className="block text-xs text-slate-500" data-id="element-68" data-mp="2v56rqru7z2qn">{m.role}</span>
                  </span>
                  {selected && <CheckIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-69" data-mp="351p28sq1rte9" />}
                </button>
              </li>;
      })}
        </ul>}
    </InlinePopover>;
}